import { PageHeader } from "../../commons/component/PageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import StructureComponent from "../../components/Turnero/Structure/Structure.component";
import ConsultoriosListComponent from "../../components/Turnero/Consultorios/Consutorios.List/ConsultoriosList.Component";
import QueueDisplayListComponent from "../../components/Turnero/QueueDisplays/QueueDisplay.List/QueueDisplayList.Component";

// styles
import './Offices.Details.Styles.css';


const OfficesPage = () => {

    const { t } = useTranslation();
    const [selectedSectorId, setSelectedSectorId] = useState<number | null>(null);

    return (
        <>
            <PageHeader title={t('Offices.title')} />
            <div className="StructureContainer">
                <div className="Section">
                    <StructureComponent onSectorSelected={(id: number | null) => setSelectedSectorId(id)} />
                </div>
                <div>
                    <div className="Section">
                        <QueueDisplayListComponent sectorId={selectedSectorId ?? undefined} />
                    </div>
                    <div className="Section">
                        <ConsultoriosListComponent sectorId={selectedSectorId ?? undefined} />
                    </div>
                </div>

            </div>
        </>
    );
}

export default OfficesPage;